//update ingredients modale supplements catalog
window.updateSupplementTemp = function (supplementsTemp, supplementId, supplement, supplementPrice, selectAll = false, category = "") {
    if (category != "") {
        let parentCategory = document.getElementById(category);
        let products = Array.from(parentCategory.getElementsByClassName('select-category'));
        let checkAll = parentCategory.querySelector('.check-all');

        for (let i = 0; i < products.length; i++) {
            let input = products[i].getElementsByTagName('input');
            input = input[0].checked;

            if (selectAll == true) {
                if (input == false) {
                    checkAll.classList.add('semi-checked')
                    break;
                } else {
                    checkAll.classList.remove('semi-checked')
                }
            } else {
                if (input == true) {
                    checkAll.classList.add('semi-checked')
                    break;
                } else {
                    checkAll.classList.remove('semi-checked')
                }
            }
        }
    }

    if (supplementsTemp.some(supp => supp.id == supplementId)) {
        for (let index = 0; index < supplementsTemp.length; index++) {
            if (supplementsTemp[index].id == supplementId) {
                supplementsTemp.splice(index, 1);
            }
        }
    } else { // add if not
        let newSupplement = { id: supplementId, name: supplement, price: supplementPrice };

        supplementsTemp.push(newSupplement);
    }

    //update price
    calculatePrice(supplementsTemp);
}

window.updateSupplementTempAll = function (supplementsTemp, supplementId, supplement, supplementPrice, selectAll = false, category = "") {

    let parentCategory = document.getElementById(category);
    let products = Array.from(parentCategory.getElementsByClassName('select-category'));
    let checkAll = parentCategory.querySelector('.check-all');

    if (checkAll.classList.contains('semi-checked')) {
        checkAll.classList.remove('semi-checked')
    }

    products.forEach((product) => {
        let input = product.getElementsByTagName('input');
        input[0].checked = selectAll
    })

    if (supplementsTemp.some(supp => supp.id == supplementId)) {
        for (let index = 0; index < supplementsTemp.length; index++) {
            if (supplementsTemp[index].id == supplementId && selectAll == false) {
                supplementsTemp.splice(index, 1);
            }
        }
    } else { // add if not
        let newSupplement = { id: supplementId, name: supplement, price: supplementPrice };

        if (selectAll == true) {
            supplementsTemp.push(newSupplement);
        }
    }

    //update price
    calculatePrice(supplementsTemp);
}

window.calculatePrice = (supplements, updateAll = false, updateBasePrice = false, updateQuantity = false) => {
    const addSupplement = document.getElementById('addSupplements');
    const supplementsPrice = document.getElementById('supplements-price');
    const totalComplement = document.querySelector('.total-complement');
    const totalBase = document.querySelector('.total-base');
    let newPriceSupplement = 0;

    for (let index = 0; index < supplements.length; index++) {
        let price = parseFloat(supplements[index].price);
        newPriceSupplement += price;
    }

    if (newPriceSupplement != 0) {
        supplementsPrice.innerHTML = '+ ' + new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(newPriceSupplement);

        addSupplement.setAttribute('data-price', newPriceSupplement);
    } else {
        supplementsPrice.innerHTML = '+ 0,00 €';
        addSupplement.setAttribute('data-price', 0);
    }

    if (updateAll) {
        let basePrice = (updateBasePrice) ? parseFloat(updateBasePrice) : parseFloat(totalComplement.getAttribute('data-base'));

        let quantity = (updateQuantity) ? parseInt(updateQuantity) : parseInt(document.querySelector('.qtn-input').value);

        let supplementPrice = parseFloat(newPriceSupplement) * quantity;
        let base = basePrice * quantity;
        let newPriceTotal = base + supplementPrice;

        totalComplement.setAttribute('data-base', basePrice);

        totalBase.innerHTML = "Prix de base : " + new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(basePrice)

        totalComplement.innerHTML = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(newPriceTotal);
    }
}

window.removeSupplement = (supplements, supplementsTemp, supplementId) => {
    //remove item from array
    if (supplements.some(supp => supp.id == supplementId)) { //remove if present
        for (let index = 0; index < supplements.length; index++) {
            if (supplements[index].id == supplementId) {
                supplements.splice(index, 1);

                //uncheck supplements
                let input = document.getElementById(supplementId);
                input.checked = false;
            }
        }
    }

    //update price supplement
    calculatePrice(supplements, true);
    removeSupplementTemp(supplementsTemp, supplementId);
}

window.removeSupplementTemp = (supplementsTemp, supplementId, category) => {
    //remove item from array
    if (supplementsTemp.some(supp => supp.id == supplementId)) { //remove if present
        for (let index = 0; index < supplementsTemp.length; index++) {
            if (supplementsTemp[index].id == supplementId) {
                supplementsTemp.splice(index, 1);

                let input = document.getElementById(supplementId);
                input.checked = false;
            }
        }
    }
}

window.removeSupplementTempAll = function (supplementsTemp, supplementId, category = "") {
    let parentCategory = document.getElementById(category);
    if(parentCategory){
        let products = Array.from(parentCategory.getElementsByClassName('select-category'));
        let checkAll = parentCategory.querySelector('.check-all');
        let uncheckAll = false;

        //remove checkAll if no checkbox checked
        products.every(product => {
            let input = product.getElementsByTagName('input');
            let id = input[0].getAttribute('ID');

            if (supplementsTemp.some(supp => supp.id == id)) { //check if present
                uncheckAll = false;
                return false;
            }

            uncheckAll = true;
            // Make sure you return true. If you don't return a value, `every()` will stop.
            return true;
        });

        //uncheck box that is not in suppTemp
        products.forEach(product => {
            let input = product.getElementsByTagName('input');
            let id = input[0].getAttribute('ID');

            if (supplementsTemp.some(supp => supp.id == id)) { //check if present
                input[0].checked = true;
            } else {
                input[0].checked = false;
            }
        });

        if (uncheckAll) {
            if (checkAll.classList.contains('semi-checked')) {
                checkAll.classList.remove('semi-checked')
            }

            checkAll.checked = false;
        }

        //update price
        calculatePrice(supplementsTemp);
    }
}

//menu header animation
window.amimHeader = (activation) => {
    let parentHeader = document.getElementById('header-container');
    let header = document.getElementById('header');
    let modal = document.getElementById('modal-showModalPersonnalisation');
    let content = modal.querySelector('#header-bg-img');

    if (activation == true) {
        header.parentNode.removeChild(header);
        content.prepend(header);
    } else {
        setTimeout(() => {
            header = document.getElementById('header');
            content.removeChild(header);
            parentHeader.prepend(header);
        }, 350);
    }
}